import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor, HttpQuery } from '../Shared/HttpRequestExecutor';
import { OrderedReference, Reference } from '../Shared/SharedModels';

export const searchAtcCodes: HttpQuery<Reference[]> = (config, query = '', limit = 0) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable(
        `api/v1/references/atc/search?query=${query}&limit=${limit}`,
        config
    );

export const searchPoisonSchedules: HttpQuery<OrderedReference[]> = (config, query = '', limit = 0) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable(
        `api/v1/references/poison-schedule/search?query=${query}&limit=${limit}`,
        config
    );

export const searchMedicinalProducts: HttpQuery<string[]> = (config, query = '', limit = 0) =>
    getExecutor(getConfig().apiEndpoints.medicationsManagement).getCancellable(
        `api/v1/references/medicinal-product/search?query=${query}&limit=${limit}`,
        config
    );
